var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3682 20.8118L29.0757 25.5194C29.2268 25.6697 29.3466 25.8484 29.4284 26.0452C29.5102 26.242 29.5523 26.453 29.5523 26.6661C29.5523 26.8792 29.5102 27.0902 29.4284 27.2869C29.3466 27.4837 29.2268 27.6624 29.0757 27.8127C27.4204 29.4684 25.2233 30.4713 22.8879 30.6372C20.5525 30.8031 18.2356 30.1209 16.3629 28.7158L13.5629 26.6145C10.4632 24.2898 7.70979 21.5363 5.38508 18.4367L3.28375 15.6367C1.87868 13.7639 1.19644 11.4471 1.36235 9.11171C1.52825 6.77632 2.53115 4.57919 4.18686 2.92383C4.33718 2.77279 4.51586 2.65294 4.71265 2.57115C4.90943 2.48937 5.12042 2.44727 5.33352 2.44727C5.54662 2.44727 5.75762 2.48937 5.9544 2.57115C6.15118 2.65294 6.32987 2.77279 6.48019 2.92383L11.1877 7.63139C11.521 7.96477 11.7083 8.41687 11.7083 8.88828C11.7083 9.35968 11.521 9.81178 11.1877 10.1452L9.37264 11.9603C9.23096 12.1005 9.13742 12.2821 9.10548 12.4789C9.07353 12.6757 9.10483 12.8775 9.19486 13.0554C11.304 17.2745 14.7251 20.6955 18.9442 22.8047C19.1221 22.8948 19.3239 22.926 19.5207 22.8941C19.7175 22.8622 19.899 22.7686 20.0393 22.6269L21.8526 20.8136C22.0177 20.6483 22.2138 20.5172 22.4296 20.4277C22.6454 20.3383 22.8768 20.2922 23.1104 20.2922C23.344 20.2922 23.5754 20.3383 23.7912 20.4277C24.007 20.5172 24.2031 20.6483 24.3682 20.8136V20.8118Z",
    stroke: "url(#paint0_linear_916_1364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_1364",
    x1: 1.33789,
    y1: 16.5545,
    x2: 29.5523,
    y2: 16.5545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503D75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7c3db3ab84add0d4f53b7902afcfde84.svg";
export { ForwardRef as ReactComponent };